import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionLabel, StaggerGroup, StaggerItem } from "@/components/Reveal";
import { INVEST_STEPS, CONTACT } from "@/lib/content";

export default function NextSteps() {
    return (
        <section
            id="invest"
            className="relative border-t border-white/10 bg-navy-900"
            data-testid="next-steps"
        >
            <div className="mx-auto max-w-7xl px-6 py-24 md:px-12 md:py-32">
                <Reveal>
                    <SectionLabel index="12">Next Steps</SectionLabel>
                </Reveal>

                <div className="grid gap-14 md:grid-cols-12">
                    <div className="md:col-span-5">
                        <Reveal delay={0.1}>
                            <h2 className="font-display text-3xl md:text-5xl font-light leading-tight tracking-tight text-white">
                                A private Seed round into HEIR PTE. LTD.
                            </h2>
                        </Reveal>
                        <Reveal delay={0.2}>
                            <div className="mt-10 border border-gold/25 bg-gold/[0.05] p-8">
                                <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-gold">
                                    Minimum Investment
                                </p>
                                <p className="mt-3 font-display text-5xl font-light text-white">
                                    $50,000
                                </p>
                            </div>
                        </Reveal>
                        <Reveal delay={0.3}>
                            <a
                                href={CONTACT.mailto}
                                data-testid="invest-cta"
                                className="group mt-6 flex w-full items-center justify-between border border-gold/60 bg-gold/[0.04] px-8 py-5 transition-all duration-300 hover:bg-gold"
                            >
                                <span className="font-mono text-xs uppercase tracking-[0.2em] text-gold transition-colors group-hover:text-navy-950">
                                    Begin the Process
                                </span>
                                <ArrowUpRight className="h-5 w-5 text-gold transition-all duration-300 group-hover:translate-x-1 group-hover:-translate-y-1 group-hover:text-navy-950" />
                            </a>
                        </Reveal>
                        <Reveal delay={0.35}>
                            <p className="mt-5 text-sm text-white/50">
                                We respond to qualified inquiries promptly ·{" "}
                                <a
                                    href={CONTACT.mailto}
                                    className="text-gold hover:underline"
                                >
                                    {CONTACT.email}
                                </a>
                            </p>
                        </Reveal>
                    </div>

                    <div className="md:col-span-6 md:col-start-7">
                        <StaggerGroup className="space-y-0">
                            {INVEST_STEPS.map((step, i) => (
                                <StaggerItem key={step}>
                                    <div className="group flex items-start gap-6 border-b border-white/10 py-6 transition-colors duration-300 hover:bg-white/[0.02]">
                                        <span className="font-mono text-sm text-gold">
                                            {String(i + 1).padStart(2, "0")}
                                        </span>
                                        <p className="text-base md:text-lg text-white/80">
                                            {step}
                                        </p>
                                    </div>
                                </StaggerItem>
                            ))}
                        </StaggerGroup>
                    </div>
                </div>
            </div>
        </section>
    );
}
